import { FC } from 'react';
import classNames from 'classnames';
import { sanitize } from 'isomorphic-dompurify';

type Props = {
  description: string;
  text: string;
  className?: string;
};

export const SustainabilitySpotBlock: FC<Props> = ({ description, text, className }) => {
  return (
    <div className={classNames('rounded-md border border-green-100 bg-green-50 p-4', className)}>
      <h3 className="heading-6">{text}</h3>
      <p
        className="paragraph"
        dangerouslySetInnerHTML={{ __html: sanitize(description as string) }}
      />
    </div>
  );
};
